import pointRotate from "./pointRotate.js";
/**
    Rotates a point around a given origin.
    @param poly The polygon to be rotated, which should be an Array of `[x, y]` values.
    @param alpha The angle in radians to rotate.
    @param origin The origin point of the rotation, which should be an `[x, y]` formatted Array.
*/ export default function(poly, alpha) {
    var origin = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [
        0,
        0
    ];
    return poly.map(function(p) {
        return pointRotate(p, alpha, origin);
    });
}

//# sourceMappingURL=polygonRotate.js.map